import { createContext, useContext } from 'react';
import { useTokens } from '../tokens';

/**
 * Contexto interno do PresetBuilder Compound Component.
 *
 * Vive em arquivo próprio (não em index.jsx) pra evitar ciclo de imports:
 *   index.jsx importa sections/* → sections/* importam context daqui.
 * Se context estivesse em index.jsx, sections importariam index → ciclo.
 *
 * Quem provê o valor é o `<PresetBuilder>` (orchestrator). Sections consomem
 * via `usePresetBuilder()` — não recebem props duplicadas.
 */
const PresetBuilderContext = createContext(null);

export const PresetBuilderProvider = PresetBuilderContext.Provider;

export function usePresetBuilder() {
    const ctx = useContext(PresetBuilderContext);
    if (!ctx) {
        throw new Error('usePresetBuilder deve ser usado dentro de <PresetBuilder>');
    }
    return ctx;
}

/**
 * PSection — header compartilhado entre as 4 sections do builder.
 * Mora aqui (e não em index.jsx) pelo mesmo motivo do context: evita ciclo
 * sections → index.
 */
export function PSection({ title, children, action, hint }) {
    const T = useTokens();
    return (
        <div style={{ marginBottom: 18 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
                <span
                    style={{
                        flex: 1,
                        fontSize: 10,
                        fontWeight: 700,
                        letterSpacing: 0.6,
                        textTransform: 'uppercase',
                        color: T.muted,
                    }}
                >
                    {title}
                </span>
                {action}
            </div>
            {hint && <div style={{ fontSize: 11, color: T.subtle, marginBottom: 6 }}>{hint}</div>}
            {children}
        </div>
    );
}
